import { Image } from "antd";
import { LogoIcon } from "config/IconConfig";

export const LogoContainer = () => {
  return (
    <div className="logo-container">
      <Image src={LogoIcon} preview={false} alt="logo" height={100} />
    </div>
  );
};

export default LogoContainer;
